// 定义中文语言包对象
export default {
    Language: '繁體中文',
    signIn: '登入',
    navigateBar: {
        homePage: '首頁',
        newsInformation: '新聞資訊',
        productCenter: '產品中心',
        aboutUs: '公司簡介',
    },
    title: {
        companyName: '澤科技',
        slogan: '追求極致創意',
        newsInformation: '新聞資訊',
        productCenter: '產品中心',
        aboutUs: '走進鋮澤',
        companyNews: '公司新聞',
        industryNews: '行業動態',
    },
    aboutUs:{
        aboutUs: '公司簡介',
        aboutUsText: 'CCT（HK）LIMITED成立於2007年，是電子烟行業最早的開拓者之一，已形成完整的品質管制體系和强大的研發能力，擁有400多項國內外專利授權記錄。',
        developmentHistory: '發展歷程',
        corporateCulture: '企業文化',
        corporateCultureText1: '用戶至上：始終將用戶需求放在首位，致力於提供安全、優質、創新的產品和服務',
        corporateCultureText2: '誠信經營：堅持誠信為本，遵守法律法規，恪守商業道德，維護行業良好生態',
        corporateCultureText3: '創新驅動：鼓勵創新思維，持續投入研發，推動技術進步，為用戶帶來更優質的產品體验',
        corporateCultureText4: '合作共贏：與合作夥伴攜手共進，建立長期穩定的合作關係，實現互利共贏',
        corporateCultureText5: '社會責任：積極履行社會責任，關注青少年保護，宣導理性消費，為社會發展貢獻力量',
        qualificationAndHonor: '國際資質認證',
        team: '團隊風采',
        cooperativePartner: '合作夥伴',
        clickImage: '點擊圖片查看大圖',
    },
    footer: {
        aboutUs: '走進鋮澤',
        newsInformation: '新聞資訊',
        productCenter: '產品中心',
        contactUs: '聯繫我們',
        child:{
            developmentHistory: '發展歷程',
            corporateCulture: '企業文化',
            qualificationAndHonor: '國際資質認證',
            cooperativePartner: '合作夥伴',
            companyNews: '公司新聞',
            industryNews: '行業動態',
            productIntroduction: '產品介紹',
            email: '郵箱： garyking0073@gmail.com',
            phone: '電話：852-88881234',
            address: '地址：FLAT G 2/F LEAPONT CTR 18-28 WO LIU HANG RD FO TAN HONG KONG',
        }
    },
};
